import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * FeatureUnavailable — rendered (instead of the page content) when the
 * signed-in user's institution has the feature disabled by the master admin.
 * The backend independently enforces the same policy with 403s.
 */
export default function FeatureUnavailable({ featureLabel = 'This feature' }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const home = {
    admin: '/admin-dashboard',
    system_admin: '/admin-dashboard',
    university: '/uni-dashboard',
    student: '/student-dashboard',
    faculty: '/faculty-dashboard',
    tpo: '/tpo-dashboard',
    pop: '/pop-dashboard',
  }[user.role] || '/login';

  return (
    <div style={{
      minHeight: '70vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '14px',
      padding: '40px 20px', textAlign: 'center',
    }}>
      <div style={{ fontSize: '44px' }}>🔒</div>
      <h2 style={{ margin: 0, color: 'var(--text-primary, #1a1a2e)' }}>
        {featureLabel} is not available for your institution
      </h2>
      <p style={{ margin: 0, maxWidth: '480px', color: 'var(--text-secondary, #555)' }}>
        Your institution administrator has not enabled this module.
        If you believe you should have access, please contact your institution admin.
      </p>
      <button
        onClick={() => navigate(home)}
        style={{
          padding: '10px 22px', borderRadius: '8px', border: 'none',
          background: 'var(--primary, #4f46e5)', color: '#fff',
          fontWeight: 600, cursor: 'pointer', marginTop: '6px',
        }}
      >
        Back to dashboard
      </button>
    </div>
  );
}
